import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const IroningFacilityIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "IroningFacilityIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M6.87233 21.9648C6.72425 21.9648 6.57618 21.9083 6.4632 21.7953C6.23724 21.5694 6.23724 21.203 6.4632 20.977L15.1397 12.3006C15.3656 12.0746 15.732 12.0746 15.958 12.3006C16.1839 12.5265 16.1839 12.8929 15.958 13.1188L7.28147 21.7953C7.16849 21.9083 7.02041 21.9648 6.87233 21.9648Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0278 21.9648C17.8797 21.9648 17.7316 21.9083 17.6187 21.7953L8.94219 13.1188C8.71623 12.8929 8.71623 12.5265 8.94219 12.3006C9.16815 12.0746 9.5345 12.0746 9.76046 12.3006L18.437 20.977C18.6629 21.203 18.6629 21.5694 18.437 21.7953C18.324 21.9083 18.1759 21.9648 18.0278 21.9648Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.5068 13.2883H3.15381C2.83426 13.2883 2.5752 13.0293 2.5752 12.7097V10.2307C2.5752 9.91114 2.83426 9.65209 3.15381 9.65209H20.5068C20.9925 9.65209 21.449 9.84124 21.7924 10.1847C22.1357 10.5276 22.3249 10.9843 22.3249 11.4702C22.3249 11.9561 22.1357 12.4128 21.792 12.756C21.449 13.0992 20.9925 13.2883 20.5068 13.2883ZM3.73242 12.1311H20.5068C20.6833 12.1311 20.8492 12.0624 20.974 11.9376C21.099 11.8127 21.1677 11.6468 21.1677 11.4702C21.1677 11.2936 21.099 11.1278 20.9743 11.0031C20.8492 10.878 20.6833 10.8093 20.5068 10.8093H3.73242V12.1311Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.73155 10.8093H5.01308C4.01056 10.8093 3.19495 9.9937 3.19495 8.9912C3.19495 8.50533 3.38418 8.04871 3.72779 7.70544C4.07084 7.36226 4.5274 7.17311 5.01308 7.17311H8.73155C9.73407 7.17311 10.5497 7.9887 10.5497 8.9912C10.5497 9.9937 9.73407 10.8093 8.73155 10.8093ZM5.01308 8.33032C4.83657 8.33032 4.67068 8.39904 4.54593 8.52383C4.42089 8.64876 4.35216 8.81464 4.35216 8.99119C4.35216 9.3556 4.64865 9.65208 5.01308 9.65208H8.73155C9.09598 9.65208 9.39247 9.3556 9.39247 8.99119C9.39247 8.62678 9.09598 8.33031 8.73155 8.33031L5.01308 8.33032Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.11181 8.33029H4.39334C3.39082 8.33029 2.57521 7.51469 2.57521 6.51219C2.57521 6.0262 2.76447 5.56955 3.10812 5.22635C3.4511 4.88326 3.90766 4.69411 4.39334 4.69411H8.11181C9.11433 4.69411 9.92994 5.5097 9.92994 6.5122C9.92994 7.5147 9.11433 8.33029 8.11181 8.33029ZM4.39334 5.85131C4.21683 5.85131 4.05094 5.92003 3.92619 6.04482C3.80112 6.16974 3.73242 6.33559 3.73242 6.51218C3.73242 6.87659 4.02891 7.17307 4.39334 7.17307H8.11181C8.47624 7.17307 8.77273 6.87659 8.77273 6.51218C8.77273 6.14777 8.47624 5.8513 8.11181 5.8513L4.39334 5.85131Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.73155 5.85129H5.01308C4.01056 5.85129 3.19495 5.0357 3.19495 4.0332C3.19495 3.54729 3.38418 3.09065 3.72782 2.7474C4.07087 2.40425 4.52743 2.2151 5.01308 2.2151H8.73155C9.73407 2.2151 10.5497 3.0307 10.5497 4.0332C10.5497 5.0357 9.73407 5.85129 8.73155 5.85129ZM5.01308 3.37231C4.83659 3.37231 4.67068 3.44103 4.54593 3.56584C4.42087 3.69074 4.35216 3.85663 4.35216 4.0332C4.35216 4.39761 4.64865 4.69408 5.01308 4.69408H8.73155C9.09598 4.69408 9.39247 4.39762 9.39247 4.0332C9.39247 3.66878 9.09598 3.37231 8.73155 3.37231H5.01308Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.2673 10.8093H14.3093C13.9898 10.8093 13.7307 10.5503 13.7307 10.2307V7.90192C13.7307 6.98773 13.9081 6.09597 14.2579 5.25141C14.6078 4.40681 15.113 3.65081 15.7595 3.0044L16.3791 2.38462C16.4876 2.27607 16.6348 2.21509 16.7883 2.21509C16.9418 2.21509 17.089 2.27606 17.1975 2.3846L17.8172 3.00445C18.4637 3.65079 18.9689 4.40681 19.3187 5.25141C19.6686 6.09597 19.8459 6.98772 19.8459 7.90192V10.2307C19.8459 10.5502 19.5869 10.8093 19.2673 10.8093ZM14.8879 9.65209H18.6887V7.90192C18.6887 7.14047 18.541 6.3977 18.2496 5.69426C17.9582 4.99079 17.5374 4.36111 16.999 3.82272L16.7883 3.61204L16.5778 3.82265C16.0393 4.36111 15.6185 4.99079 15.3271 5.69426C15.0357 6.39771 14.888 7.14046 14.888 7.90192L14.8879 9.65209Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default IroningFacilityIcon;
